import Resolver from '../Resolver';
import { actions } from '../actions';

const getter = (interval) => {
	const coordinates = [{
		latitude: interval.since.latitude,
		longitude: interval.since.longitude
	}];
	if (interval.until) coordinates.push({
		latitude: interval.until.latitude,
		longitude: interval.until.longitude
	});
	return coordinates;
}

let resolver = null;
const connect = (store) => {
	resolver = new Resolver(store, actions.idling.exportProgress, getter);
}

export { resolver, connect }
